import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import React from "react";
import SpinnerButton from "../../../app/components/buttons/SpinnerButton";
import ErrorText from "../../../app/components/ErrorText";
import { RequestStateDto } from "../../../app/dtos/RequestStateDto";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectModalId } from "../../modal/state/modalSelectors";
import { closeModal } from "../../modal/state/modalSlice";
import { ProviderDto } from "../dtos/ProviderDto";
import { ProviderFormDto } from "../dtos/ProviderFormDto";
import { useProviderForm } from "../hooks/useProviderForm";
import ProviderFormFields from "./ProviderFormFields";

export const providerModalId = "provider-form-modal";

interface Props {
  provider?: ProviderDto;
  onSubmit: (dto: ProviderFormDto) => Promise<void>;
  requestState: RequestStateDto;
}

const ProviderFormDialog: React.FC<Props> = ({
  provider,
  onSubmit,
  requestState,
}) => {
  //#region State
  const modalId = useAppSelector(selectModalId);
  const dispatch = useAppDispatch();
  const {
    form: { clearForm, isValid, control },
    handlers: { handleSubmit },
  } = useProviderForm(onSubmit, provider);

  const { isLoading, error } = requestState;
  //#endregion

  //#region
  const handleCloseModal = () => {
    clearForm();
    dispatch(closeModal());
  };
  //#endregion

  return (
    <Dialog open={modalId === providerModalId} maxWidth="md" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          {provider ? "Edit" : "Create"} Provider{" "}
          <ErrorText error={error?.message} />
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <ProviderFormFields control={control} disabled={isLoading} />
          </Grid>
        </DialogContent>
        <DialogActions>
          <SpinnerButton
            content="Cancel"
            showSpinner={false}
            type="button"
            onClick={handleCloseModal}
            disabled={isLoading}
          />
          <SpinnerButton
            showSpinner={isLoading}
            content="Save"
            color="primary"
            type="submit"
            disabled={!isValid || isLoading}
          />
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ProviderFormDialog;
